import React, { useEffect, useRef, useState } from 'react';
import './AchievementSection.css';

const AchievementSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: '-50px 0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="achievement-section" ref={sectionRef}>
      <div className="achievement-container">
        <div className={`achievement-header ${isVisible ? 'animate-up' : ''}`}>
          <p className="achievement-subtitle">ACHIEVEMENTS</p>

        </div>

        <div className={`achievement-content ${isVisible ? 'slide-up' : ''}`}>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 16L3 17V21H21V17L19 16V13L12 2L5 13V16Z" stroke="#3b82f6" strokeWidth="2" fill="none" />
                    <circle cx="12" cy="7" r="2" stroke="#3b82f6" strokeWidth="2" fill="none" />
                    <path d="M12 15l-3.09-3.09L7.5 14.32l4.59 4.59 7.5-7.5-1.41-1.41L12 15z" fill="#3b82f6" />
                  </svg>
                </svg>
              </div>
              <div className="testimonial-content">
                <h3>ML-Quest Hackathon Winner</h3>
                <p className="testimonial-location">Guraisoni College of Engineering, Nagpur</p>
                <p className="testimonial-description">Competed against top participants and emerged victorious in this prestigious machine learning competition, demonstrating exceptional problem-solving skills and technical expertise.</p>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 16L3 17V21H21V17L19 16V13L12 2L5 13V16Z" stroke="#3b82f6" strokeWidth="2" fill="none" />
                    <circle cx="12" cy="7" r="2" stroke="#3b82f6" strokeWidth="2" fill="none" />
                    <path d="M12 15l-3.09-3.09L7.5 14.32l4.59 4.59 7.5-7.5-1.41-1.41L12 15z" fill="#3b82f6" />
                  </svg>
                </svg>
              </div>
              <div className="testimonial-content">
                <h3>Top 1% National Coding Excellence</h3>
                <p className="testimonial-location">Sri Rama Krishna College of Engineering & Technology</p>
                <p className="testimonial-description">Achieved top 1% ranking out of 600 participants in a highly competitive national-level coding contest, showcasing advanced programming skills and algorithmic thinking.</p>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 16L3 17V21H21V17L19 16V13L12 2L5 13V16Z" stroke="#3b82f6" strokeWidth="2" fill="none" />
                    <circle cx="12" cy="7" r="2" stroke="#3b82f6" strokeWidth="2" fill="none" />
                    <path d="M12 15l-3.09-3.09L7.5 14.32l4.59 4.59 7.5-7.5-1.41-1.41L12 15z" fill="#3b82f6" />
                  </svg>
                </svg>
              </div>
              <div className="testimonial-content">
                <h3>Tech Quest Runner-Up</h3>
                <p className="testimonial-location">PSG College of Technology</p>
                <p className="testimonial-description">Secured second place in Data Analytics - Designing Dashboard competition, demonstrating strong analytical skills and creative dashboard design capabilities.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AchievementSection;
